import { StudioActionTypes } from './studio.types';

export const initialState = {
  account: null,
  credits: null,
  product: null,
  loading: false,
  showLoadingError: false,
  formCheck: {
    answered: undefined,
  },
  formSend: [],
  templates: {},
  templatesLoading: false,
  available: undefined,
  errorGeneratingLogo: false,
  logoGenerated: false,
  listLogos: [],
  logoBuilder: null,
  logoBuilderLoading: false,
  buildingLogo: false,
  clickOnMenu: false,
  products: {
    data: null,
    loading: false,
    status: null,
  },
  provisionFree: {
    loading: false,
    status: null,
  },
  logoDownloadLoading: [],
  documentCreationLoading: false,
};

const studioReducer = (state = initialState, action) => {
  switch (action.type) {
    case StudioActionTypes.STUDIO_ACCOUNT_SET: {
      const { account, credits, product } = action.payload;
      return {
        ...state,
        account,
        credits,
        product,
      };
    }
    case StudioActionTypes.STUDIO_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case StudioActionTypes.STUDIO_ACCOUNT_FAILURE: {
      return {
        ...state,
        showLoadingError: true,
      };
    }
    case StudioActionTypes.STUDIO_ACCOUNT_REQUEST: {
      return {
        ...state,
        showLoadingError: false,
      };
    }
    case StudioActionTypes.STUDIO_FORM_CHECK_REQUEST: {
      return {
        ...state,
        showLoadingError: false,
      };
    }
    case StudioActionTypes.STUDIO_FORM_SEND_FAILURE:
    case StudioActionTypes.STUDIO_FORM_CHECK_FAILURE: {
      return {
        ...state,
        showLoadingError: true,
      };
    }
    case StudioActionTypes.STUDIO_FORM_CHECK_SET: {
      return {
        ...state,
        formCheck: action.payload,
      };
    }
    case StudioActionTypes.STUDIO_FORM_SEND_REQUEST: {
      return {
        ...state,
        showLoadingError: false,
        formSend: action.payload,
      };
    }
    case StudioActionTypes.STUDIO_FORM_SEND_SET: {
      return {
        ...state,
        formSend: action.payload,
      };
    }
    case StudioActionTypes.STUDIO_GET_TEMPLATES_SET: {
      return {
        ...state,
        templates: {
          ...state.templates,
          ...action.payload,
        },
      };
    }
    case StudioActionTypes.STUDIO_GET_TEMPLATES_LOADING: {
      return {
        ...state,
        templatesLoading: action.payload,
      };
    }
    case StudioActionTypes.STUDIO_LOGO_BUILDER_AVAILABILITY_SET: {
      return {
        ...state,
        available: action.payload.available,
        buildingLogo: action.payload.buildingLogo,
      };
    }
    case StudioActionTypes.STUDIO_LOGO_GENERATION_REQUEST: {
      return {
        ...state,
        logoBuilderLoading: action.payload,
        errorGeneratingLogo: false,
      };
    }
    case StudioActionTypes.STUDIO_LOGO_GENERATION_LOADING: {
      return {
        ...state,
        logoBuilderLoading: action.payload,
      };
    }
    case StudioActionTypes.STUDIO_LOGO_GENERATION_FAILURE: {
      return {
        ...state,
        errorGeneratingLogo: true,
      };
    }
    case StudioActionTypes.STUDIO_LOGO_GENERATION_SUCCESS: {
      return {
        ...state,
        logoGenerated: true,
      };
    }
    case StudioActionTypes.STUDIO_LOGO_GENERATION_SET: {
      return {
        ...state,
        listLogos: [...state.listLogos, ...action.payload.logos],
        logoBuilder: action.payload.credits,
      };
    }
    case StudioActionTypes.STUDIO_LOGO_BUILDER_CLICKED_ON_MENU: {
      return {
        ...state,
        clickOnMenu: !state.clickOnMenu,
      };
    }
    case StudioActionTypes.STUDIO_LOGO_GENERATION_RESET_STATUS: {
      return {
        ...state,
        listLogos: [],
        errorGeneratingLogo: false,
      };
    }
    case StudioActionTypes.STUDIO_PRODUCTS_SET: {
      return {
        ...state,
        products: {
          ...state.products,
          data: action.payload,
        },
      };
    }
    case StudioActionTypes.STUDIO_PRODUCTS_LOADING: {
      return {
        ...state,
        products: {
          ...state.products,
          loading: action.payload,
        },
      };
    }
    case StudioActionTypes.STUDIO_PRODUCTS_SUCCESS: {
      return {
        ...state,
        products: {
          ...state.products,
          status: 'success',
        },
      };
    }
    case StudioActionTypes.STUDIO_PRODUCTS_FAILURE: {
      return {
        ...state,
        products: {
          ...state.products,
          status: 'failure',
        },
      };
    }
    case StudioActionTypes.STUDIO_LOGO_DOWNLOAD_REQUEST: {
      return {
        ...state,
        logoDownloadLoading: [...state.logoDownloadLoading, action.payload],
      };
    }
    case StudioActionTypes.STUDIO_LOGO_DOWNLOAD_SUCCESS:
    case StudioActionTypes.STUDIO_LOGO_DOWNLOAD_FAILURE: {
      return {
        ...state,
        logoDownloadLoading: state.logoDownloadLoading.filter(
          item => item !== action.payload,
        ),
      };
    }
    case StudioActionTypes.STUDIO_REQUEST_PROVISION_FREE_PLAN_LOADING: {
      return {
        ...state,
        provisionFree: {
          ...state.provisionFree,
          loading: action.payload,
        },
      };
    }
    case StudioActionTypes.STUDIO_REQUEST_PROVISION_FREE_PLAN_SUCCESS: {
      return {
        ...state,
        provisionFree: {
          ...state.provisionFree,
          status: 'success',
        },
      };
    }
    case StudioActionTypes.STUDIO_REQUEST_PROVISION_FREE_PLAN_FAILURE: {
      return {
        ...state,
        provisionFree: {
          ...state.provisionFree,
          status: 'failure',
        },
      };
    }
    case StudioActionTypes.STUDIO_DOCUMENT_CREATION_LOADING: {
      return {
        ...state,
        documentCreationLoading: action.payload,
      };
    }
    default:
      return state;
  }
};

export default studioReducer;
